import { render } from "./ProductContent.vue?vue&type=template&id=3dd859d7"
import script from "./ProductContent.vue?vue&type=script&lang=js"
export * from "./ProductContent.vue?vue&type=script&lang=js"

import "./ProductContent.vue?vue&type=style&index=0&id=3dd859d7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__